export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M19 3a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h14zM5 19h14v-5h-3.105c-.407 1.72-1.951 3-3.795 3h-.2a3.901 3.901 0 01-3.795-3H5v5zm0-7h4a1 1 0 011 1v.1a1.9 1.9 0 001.9 1.9h.2a1.9 1.9 0 001.9-1.9V13a1 1 0 011-1h4V5H5v7z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};